import React, { useEffect, useState, useRef } from "react";

import "../css/CommonStyle.css";
import "../css/ItemsInACarModel.css";

import ic_mirror_1 from "../img/ic_mirror_1.png";
import ic_mirror_2 from "../img/ic_mirror_2.png";
import ic_mirror_3 from "../img/ic_mirror_3.png";
import ic_mirror_4 from "../img/ic_mirror_4.png";
import ic_mirror_5 from "../img/ic_mirror_5.png";
import ic_mirror_6 from "../img/ic_mirror_6.png";
import Header from "./Header";
import axios from "axios";
import CartSidebar from "./CartSidebar";
import ic_dropdwon from "../img/ic_down_dropdown.png";

import normal_checkbox from "../img/ic_normal_checkbox.png"
import selected_checkbox from "../img/ic_selected_checkbox.png"

import ic_chip_close from "../img/ic_chip_close.png";
import "../css/SubCategory.css";
import ic_continue_blue_arrow from "../img/ic_continue_blue_arrow.png";

import { useNavigate } from "react-router-dom";
import ic_collapse from "../img/ic_collapse.png";

import ic_success from "../img/ic_added_to_cart_check.png";
import ic_warning from "../img/ic_chip_close.png";
import "../css/CustomerDetails.css";


function CustomerDetails() {

    const [orderSavingResult, setOrderSavingResult] = useState(null)

    let initialCustomerDetails = {
        customer_name: "",
        customer_mobile_number: "",
        customer_email_id: ""
    }

    const [customerDetailsObject, setCustomerDetailsObject] = useState(initialCustomerDetails)

    const navigate = useNavigate();

    const makeRef = useRef("ALL");
    const modelRef = useRef("ALL");
    const groupRef = useRef("ALL");

    const getLocalStorageValues = () => {


        if (localStorage.getItem("selected_make") != null) {
            makeRef.current = localStorage.getItem("selected_make")
        }
        if (localStorage.getItem("selected_model") != null) {
            modelRef.current = localStorage.getItem("selected_model")
        }
        if (localStorage.getItem("selected_group") != null) {
            groupRef.current = localStorage.getItem("selected_group")
        }
    }

    getLocalStorageValues()

    const [arrayOfBrands, setArrayOfBrands] = useState(null)

    const [isCallingBrandAPI, setIsCallingBrandAPI] = useState(false)
    const [showYearDropDown, setShowYearDropDown] = useState(false);
    const [selectedYear, setSelectedYear] = useState("Select");
    const [listOfYears, setListOfYears] = useState([])

    let pathArray = [{ name: "make", path: "" }, { name: "model", path: "model" },
    { name: "group", path: "group" }]

    const [itemList, setItemList] = useState(null)
    const [isCallingYearAPI, setIsCallingYearAPI] = useState(false)
    const [isCallingApi, setIsCallingAPI] = useState(false)

    let selected_year_chain = "ALL"
    let selected_brand_chain = "ALL"

    const getItemsFromAPI = () => {

        setIsCallingAPI(true)

        if (listOfYears != null) {
            let filteredYears = listOfYears.filter((item) => {
                return item.is_selected
            })

            console.log(" filteredYears ", filteredYears)

            if (filteredYears.length > 0) {
                let filteredYearsArray = filteredYears.map((item) => item.yearName)
                selected_year_chain = filteredYearsArray.join("_")
            }
        }

        if (arrayOfBrands != null) {
            let filteredBrands = arrayOfBrands.filter((item) => {
                return item.is_selected
            })

            console.log(" filteredBrands ", filteredBrands)

            if (filteredBrands.length > 0) {
                let filteredBrandsCodeArray = filteredBrands.map((item) => item.Brand)
                selected_brand_chain = filteredBrandsCodeArray.join("-")
            }
        }

        let subcategoryUrl = "https://cubixweberp.com:197/api/InventMasters/InventoryLevel4?cmpcode=AUTOLAND&guid=82D38C38-65BF-46AF-8871-D8219757842C&mod=LEVEL4&lvl1=A1&lvl2=A2&lvl3=A3"

        axios.get(subcategoryUrl).then((res) => {

            setTimeout(() => {
                setIsCallingAPI(false)

                let newArray = res.data.map((item) => {
                    return { ...item, checked_status: false }
                })
                setItemList(newArray)
            }, 1000)


        }).catch((err) => {
            setIsCallingAPI(false)
            console.log("err is ", err)
        })
    }

    const getYearListforDropDown = () => {

        const year = (new Date()).getFullYear();

        let yearArray = Array.from(new Array(50), (val, index) => {
            return { yearName: year - index }
        });

        console.log(" yearArray ", yearArray)
        let mappedYearArray = yearArray.map((item) => {
            return { ...item, is_selected: false }
        })

        setListOfYears(mappedYearArray);

        let url = `https://cubixweberp.com:197/api/InventMasters/Inventoryyears?cmpcode=AUTOLAND&guid=F285D054-3200-4413-A624-DAD26D8A5616&mod=YEAR&lvl1=${makeRef.current}&lvl2=${modelRef.current}&lvl3=${groupRef.current}`


        setIsCallingYearAPI(true)
        axios.get(url).then((res) => {
            console.log("res ", res)

            let mappedArray = res.data.map((item) => {
                return { yearName: item.year, is_selected: false }
            })

            setListOfYears(mappedArray);

            setIsCallingYearAPI(false)
        }).catch((err) => {
            console.log("err ", err)
            setIsCallingYearAPI(false)
        })

    }

    const getBrands = () => {

        let url = `https://cubixweberp.com:197/api/InventMasters/InventoryLevel5?cmpcode=AUTOLAND&guid=82D38C38-65BF-46AF-8871-D8219757842C&mod=LEVEL5&lvl1=A1&lvl2=A2&lvl3=A3&lvl4=A4&LVL5=ALL`
        setIsCallingBrandAPI(true)
        axios.get(url).then((res) => {
            console.log("res ", res)

            let mappedArray = res.data.map((item) => {
                return { ...item, is_selected: false }
            })

            setArrayOfBrands(mappedArray)

            setIsCallingBrandAPI(false)
        }).catch((err) => {
            console.log("err ", err)
            setIsCallingBrandAPI(false)
        })

    }

    useEffect(() => {
        getItemsFromAPI()
        getYearListforDropDown()
        getBrands()
    }, [])


    const clickedOnBrand = (brand) => {
        let newaaray = arrayOfBrands.map((item) => {
            if (brand == item.Brand) {
                return { ...item, is_selected: !item.is_selected }
            } else {
                return item
            }

        })
        setArrayOfBrands(newaaray)
    }


    const clickedOnYear = (yearClicked) => {
        let newaaray = listOfYears.map((item) => {
            if (yearClicked == item.yearName) {
                return { ...item, is_selected: !item.is_selected }
            } else {
                return item
            }

        })
        setListOfYears(newaaray)
    }

    const clickedOnBrandFilterChip = (brand) => {
        let newaaray = arrayOfBrands.map((item) => {
            if (brand == item.Brand) {
                return { ...item, is_selected: !item.is_selected }
            } else {
                return item
            }

        })
        setArrayOfBrands(newaaray)
    }

    const clickedOnYearFilterChip = (year) => {
        let newaaray = listOfYears.map((item) => {
            if (year == item.yearName) {
                return { ...item, is_selected: !item.is_selected }
            } else {
                return item
            }

        })
        setListOfYears(newaaray)
    }

    useEffect(() => {
        if (arrayOfBrands != null) {
            getItemsFromAPI()
        }

    }, [arrayOfBrands])

    useEffect(() => {
        if (listOfYears != null) {
            getItemsFromAPI()
        }

    }, [listOfYears])


    const reCallApi = () => {
        getLocalStorageValues()
        getItemsFromAPI()
        getYearListforDropDown()
        getBrands()
    }


    const clickedOnSubCategory = (selectedGroup) => {

        let newArray = itemList.map((item) => {
            if (item.GroupDesc == selectedGroup) {
                return { ...item, checked_status: !item.checked_status }
            } else {
                return item
            }
        })

        setItemList(newArray)
    }

    const clickedOnMakeModelContinue = () => {
        navigate("/parts")
    }

    const [checkBoxPanelList, setCheckboxpanelList] = useState([
        {
            panel_name: "year", checked_status: false,
        },
        {
            panel_name: "brand", checked_status: false,
        },
        {
            panel_name: "make_and_model", checked_status: false,
        }
    ]
    )
    const showHideCheckboxPanels = (panelName) => {

        let newArray = checkBoxPanelList.map((item) => {
            if (item.panel_name == panelName) {
                return { ...item, checked_status: !item.checked_status }
            } else {
                return item
            }
        })

        setCheckboxpanelList(newArray)
    }

    const handleInput = (e) => {

        setCustomerDetailsObject({ ...customerDetailsObject, [e.target.name]: e.target.value })

    }



    const clickedOnSubmit = () => {

        // localStorage
        let initialLocalStorageOrderItems = localStorage.getItem("autoland_ordered_items")

        console.log("initialLocalStorageOrderItems ", initialLocalStorageOrderItems)

        let initialOrderArray = null;

        if (initialLocalStorageOrderItems != null) {
            initialOrderArray = JSON.parse(initialLocalStorageOrderItems)
        }

        console.log("customerDetailsObject ", customerDetailsObject)

        if (customerDetailsObject.customer_name.length == 0 || customerDetailsObject.customer_mobile_number.length == 0) {
            alert("Plese fill the fields and submit")
        }

        let objectTOSendToArray = initialOrderArray.map((item) => {
            return {
                Code: item.Code,
                price: item.price,
                quantity_in_shopping_cart: Number(item.quantity_in_shopping_cart),
                ...customerDetailsObject
            }
        })

        console.log("objectTOSendToArray ", objectTOSendToArray)

        let stringifiedJSON = JSON.stringify(objectTOSendToArray);

        console.log("stringifiedJSON ", stringifiedJSON)


        axios.post('https://cubixweberp.com:197/api/orderitem?cmpcode=autoland', stringifiedJSON,

            {
                headers: {
                    // Overwrite Axios's automatically set Content-Type
                    'Content-Type': 'application/json'
                }
            }

        ).then((res) => {

            console.log("clickedOnSubmit res ", res)

            if (res.data.result == "Order Saved") {
                setOrderSavingResult("success")
                // empty the localStorage array again
                console.log("empty local storage")
                localStorage.setItem("autoland_ordered_items", JSON.stringify([]))
            } else {
                setOrderSavingResult("failure")
            }


        }).catch((err) => {
            console.log("clickedOnSubmit err ", err)
            setOrderSavingResult("failure")
        })
    }



    return (

        <div className="ItemsInACarModel-root-container common_page_bg">

            <div className="Header-wrapper">
                <Header />
            </div>

            <div className="container customer_details_container mt-4">
                <div>
                    <input placeholder="Name (required)" name="customer_name" className="Home_search_box" onChange={(e) => handleInput(e)} />
                </div>
                <div className="mt-3">
                    <input placeholder="Mobile Number (required)" name="customer_mobile_number" className="Home_search_box" onChange={(e) => handleInput(e)} />
                </div>
                <div className="mt-3">
                    <input placeholder="Email id" name="customer_email_id" className="Home_search_box" onChange={(e) => handleInput(e)} />
                </div>
                <button className="btn btn-warning mt-4" onClick={() => clickedOnSubmit()}>Submit</button>
            </div>


            {
                orderSavingResult != null &&

                <div className="popup-outer">
                    <div className="popup-inner">

                        <div className="messageToUser-container">



                            {
                                orderSavingResult == "success" ?
                                    <div>
                                        <div className="d-flex justify-content-end">
                                            <button className="btn btn-dark m-2" onClick={() => { setOrderSavingResult(null); navigate("/") }} >Close</button>
                                        </div>
                                        <div className="orderResultMessageContainer">
                                            <img src={ic_success} />
                                            <h6 className="mt-3">Order saved successfully</h6>
                                        </div>
                                    </div>

                                    :
                                    <div>
                                        <div className="d-flex justify-content-end">
                                            <button className="btn btn-dark m-2" onClick={() => setOrderSavingResult(null)} >Close</button>
                                        </div>

                                        <div className="orderResultMessageContainer">
                                            <img src={ic_warning} />
                                            <h6 className="mt-3">Could not save order, please try later</h6>
                                        </div>
                                    </div>

                            }

                        </div>

                    </div>
                </div>
            }

        </div>
    )
}

export default CustomerDetails;